import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";

import Paper from "@material-ui/core/Paper"


import Typography from "@material-ui/core/Typography";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Calendar from "react-modern-calendar-datepicker";

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import TextField from '@material-ui/core/TextField';

import Select from "react-select";



const FilterPanel = ({
                         searchText,
                         Renewal,
                         onSearchTextChange,
                         selectedDayStart,
                         onStartDateChange,
                         selectedDayEnd,
                         onEndDateChange,
                         selectedStatus,
                         onStatusChange,
                         statusOptions,
                         selectedRepresentation,
                         onRepresentationChange,
                         representationOptions,
                         onSearch,
                         onBase,
                         excel,
                         filter,
                         CustomerPhoneNumber,              // 🟢 اضافه‌شده
                         onCustomerPhoneNumberChange,        // 🟢 اضافه‌شده
                         onAddRecord,  // 🟢 اضافه شد
                     }) => {

    return (
        <Paper elevation={4} style={{ padding: 24, borderRadius: 16, marginBottom: 24 }}>
            <Grid container spacing={3} alignItems="center" dir="rtl">
                {/* جستجو */}
                <Grid item xs={2}>
                    <TextField
                        fullWidth
                        value={searchText}
                        onChange={(e) => onSearchTextChange(e.target.value)} // تغییر searchText
                    />
                </Grid>

                {/* تاریخ شروع */}
                <Grid item xs={2}>
                    <Typography variant="h7" style={{ marginBottom: 8 }}>از تاریخ </Typography>
                    <Calendar
                        renderInput={({ ref }) => (
                            <TextField
                                fullWidth
                                inputRef={ref}
                                variant="outlined"
                                value={selectedDayStart ? `${selectedDayStart.year}/${String(selectedDayStart.month).padStart(2, '0')}/${String(selectedDayStart.day).padStart(2, '0')}` : ''}
                                placeholder="از تاریخ"
                            />
                        )}
                        value={selectedDayStart}
                        onChange={(val) => {
                            console.log('onStartDateChange:', val); // لاگ برای بررسی تغییرات
                            onStartDateChange(val); // فراخوانی تابع تغییر تاریخ شروع
                        }}
                        locale="fa"
                        shouldHighlightWeekends
                    />
                </Grid>

                {/* تاریخ پایان */}
                <Grid item xs={2}>
                    <Typography variant="h7" style={{ marginBottom: 8 }}>تا تاریخ </Typography>
                    <Calendar
                        renderInput={({ ref }) => (
                            <TextField
                                fullWidth
                                inputRef={ref}
                                variant="outlined"
                                value={selectedDayEnd ? `${selectedDayEnd.year}/${String(selectedDayEnd.month).padStart(2, '0')}/${String(selectedDayEnd.day).padStart(2, '0')}` : ''}
                                placeholder="تا تاریخ"
                            />
                        )}
                        value={selectedDayEnd}
                        onChange={onEndDateChange} // فراخوانی تابع تغییر تاریخ پایان
                        locale="fa"
                        shouldHighlightWeekends
                    />
                </Grid>
                {filter === 'ALL' && (

                    <Grid item xs={2}>
                    <Typography variant="h7" style={{ marginBottom: 8 }}>شماره همراه مشتری</Typography>
                    <TextField
                        fullWidth
                        value={CustomerPhoneNumber || ''}  // اگر null یا undefined بود، رشته خالی نشون میده
                        onChange={(e) => onCustomerPhoneNumberChange && onCustomerPhoneNumberChange(e.target.value)}  // ✅ چک میکنیم اگر تابع وجود داشت اجراش کن
                        placeholder="شماره همراه را وارد کنید"
                    />
                </Grid>
                )}


                {excel !== 'Marketer' && (

                    <Grid item xs={2}>
                    <Typography variant="h7" style={{ marginBottom: 8 }}>وضعیت بیمه نامه </Typography>
                    <Select
                        isSearchable
                        placeholder="انتخاب وضعیت"
                        value={statusOptions.find(opt => opt.value === selectedStatus) || null} // بررسی وضعیت انتخاب شده
                        onChange={(val) => onStatusChange(val ? val.value : null)} // فراخوانی تابع تغییر وضعیت
                        options={statusOptions}
                        isDisabled={Renewal}

                    />
                </Grid>
                )}

                {/*{excel === 'current_customers_tb' && (*/}

                {/*    <Grid item xs={2}>*/}
                {/*        <Typography variant="h7" style={{ marginBottom: 8 }}>معرف ها </Typography>*/}
                {/*        <Select*/}
                {/*            isSearchable*/}
                {/*            placeholder="انتخاب وضعیت"*/}
                {/*            value={representationOptions.find(opt => opt.value === selectedRepresentation) || null} // بررسی وضعیت انتخاب شده*/}
                {/*            onChange={(val) => onRepresentationChange(val ? val.value : null)} // فراخوانی تابع تغییر وضعیت*/}
                {/*            options={representationOptions}*/}
                {/*            isDisabled={Renewal}*/}

                {/*        />*/}
                {/*    </Grid>*/}

                {/*)}*/}



                {/* دکمه جستجو */}
                <Grid item xs={2} style={{ textAlign: 'center' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={(e) => {
                            e.stopPropagation();
                            onSearch(); // فراخوانی تابع جستجو
                        }}
                    >
                        اعمال فیلتر
                    </Button>
                </Grid>
                <Grid item xs={2} style={{ textAlign: 'center' }}>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={(e) => {
                            e.stopPropagation();
                            onBase(); // فراخوانی تابع جستجو
                        }}
                        style={{ backgroundColor: '#d32f2f', color: '#fff' }}
                    >
                        حذف فیلتر
                    </Button>
                </Grid>

            </Grid>

            {excel === 'current_customers_tb' && (
                <Grid container spacing={3} style={{ marginTop: 24, borderTop: '1px solid #e0e0e0', paddingTop: 16 }}>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            onClick={onAddRecord}
                            style={{
                                backgroundColor: '#4caf50',
                                color: '#fff',
                                padding: '8px 24px',
                                float: 'right'  // چپ‌چین یا راست‌چین
                            }}
                        >
                            افزودن رکورد جدید
                        </Button>
                    </Grid>
                </Grid>
            )}
        </Paper>
    );
};


export default FilterPanel;
